import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface Classe {
  _id?: string,
  nom_classe: string,
  niveau: string
}

export const classeSlice = createApi({
  reducerPath: "Classe",
  baseQuery: baseQueryWithAuth("classes"),
  tagTypes: ["Classe"],
  endpoints(builder) {
    return {
      fetchClasses: builder.query<Classe[], number | void>({
        query() {
          return `/getClasses`;
        },
        providesTags: ["Classe"],
      }),
      fetchClasseId: builder.query<Classe, string | void>({
        query: (_id) => ({
          url: `/getClasse/${_id}`,
          method: "GET",
        }),
        providesTags: ["Classe"],
      }),
      addClasse: builder.mutation<void, Classe>({
        query(payload) {
          return {
            url: "/newClasse",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Classe"],
      }),
      updateClasse: builder.mutation<void, Classe>({
        query: ({ _id, ...rest }) => ({
          url: `/updateClasse/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["Classe"],
      }),
      deleteClasse: builder.mutation<void, Classe>({
        query: (_id) => ({
          url: `/deleteClasse/${_id}`,
          method: "Delete",
        }),
        invalidatesTags: ["Classe"],
      }),
    };
  },
});

export const {
 useAddClasseMutation,
 useFetchClassesQuery,
 useDeleteClasseMutation,
 useUpdateClasseMutation,
 useFetchClasseIdQuery
} = classeSlice;